<div class="switch-block">
    <h2 class="switch-header">{{ pageData.header }}</h2>
    <div class="shadow-circle">
        <div class="switch-circle"></div>
        <div class="content-holder">
            <div>
                <xm-media-image class="logo" [imageOptions]="iconOption" size="auto"></xm-media-image>
                <div class="plan-title">{{ selectedPlanData.planName }}</div>
                <div class="data-rate">${{ selectedPlanData.pricePerUnit }}/{{ selectedPlanData.priceUnit }}</div>
            </div>
        </div>
    </div>
    <p class="description" *ngIf="subhead">{{ subhead }}</p>
</div>
<div class="buttons">
    <button class="xm-btn-link-light cancel" (click)="continue()">{{ pageData.cancel }}</button>
    <button [promiseBtn]="buttonPromise" class="xm-btn-primary-dark promise-btn" (click)="onKeepMyCurrentPlan()"><span>{{ pageData.cta }}</span></button>
</div>
